import { Card, Radio, Typography } from "antd";
import { useTenant } from "../../../store/context/tenant-context";

const { Text } = Typography;

const CountrySupport = ({ country, isSelected, onCardClick }) => {
  const tenant = useTenant();
  return (
    <Card
      bordered
      style={{ borderColor: tenant.theme.colorPrimary }}
      className={`shadow-none rounded-lg w-full h-full cursor-pointer ${
        isSelected ? "border-1" : ""
      }`}
      onClick={() => onCardClick(country)}
    >
      <Radio.Group
        style={{ width: "100%" }}
        value={isSelected ? country.name : undefined}
      >
        <div className="flex items-center justify-between w-full cursor-pointer">
          <div className="flex items-center w-3/5">
            <img
              src={country.flag}
              alt={`${country.name} flag`}
              className="w-10 h-10 mr-2 rounded-full"
            />
            <Text className="max-w-full text-base truncate">
              {country.name}
            </Text>
          </div>
          <Radio value={country.name}></Radio>
        </div>
      </Radio.Group>
    </Card>
  );
};

export default CountrySupport;
